import { createFileRoute } from '@tanstack/react-router'
import ConceptPreliminaryCosts from 'Concept/components/Concept/Sections/ConceptPreliminaryCosts/ConceptPreliminaryCosts'

import { Guard } from '../../-guard'

export const Route = createFileRoute('/concept/$conceptId/cost')({
    component: () => (
        <Guard notFeatures={['profitability']}>
            <ConceptPreliminaryCosts />
        </Guard>
    ),
})
